import axios from "axios";
import {
  PORTAL_ACTION,
  BOOKING_ACTION,
  DATASOURCE_ACTION,
  updateLocationPosition
} from ".";
import { showError } from "../../Layout/actions";
import * as helpers from "../helpers";
import { portalService } from "../services";
import { deepGet, getParameterByName } from "../../../utils";

export const loadConfig = () => async dispatch => {
  const { data } = await portalService.getConfig();
  dispatch({
    type: PORTAL_ACTION.CONFIG_LOAD_SUCCESS,
    payload: { config: data }
  });
};

export const loadSpecialties = () => async dispatch => {
  const { data } = await portalService.getSpecialties();
  dispatch({
    type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
    payload: { key: "specialtyTypes", values: data.specialtyTypes }
  });
};

export const loadPractitioners = () => async dispatch => {
  const { data } = await portalService.getPractitioners();
  dispatch({
    type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
    payload: { key: "practitioners", values: data.practitioners }
  });
};

export const loadLocations = () => async dispatch => {
  const { data } = await portalService.getLocations();
  dispatch({
    type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
    payload: { key: "locations", values: data.locations }
  });
};

export const loadTimezones = () => async dispatch => {
  const { data } = await portalService.getTimezones();
  dispatch({
    type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
    payload: { key: "timeZones", values: data.locationTimezones }
  });
};

export const loadSchedules = (locationIds = null) => async dispatch => {
  const { data } = await portalService.getSchedules(locationIds);
  dispatch({
    type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
    payload: { key: "schedules", values: data.schedules }
  });
};

export const loading = loading => {
  const type = loading
    ? BOOKING_ACTION.START_LOADING
    : BOOKING_ACTION.FINISH_LOADING;
  return { type };
};

export const initialLoad = () => async dispatch => {
  dispatch(loading(true));
  if (window.location.pathname.replace("/", "") === "") {
    dispatch(
      showError({
        text: "Missing Tenant Id in URL",
        canDismiss: false
      })
    );
    return false;
  }
  const {
    getConfig,
    getSpecialties,
    getPractitioners,
    getLocations,
    getTimezones,
    getSchedules
  } = portalService;

  let locations;
  await axios
    .all([
      getConfig(),
      getSpecialties(),
      getPractitioners(),
      getLocations(),
      getTimezones()
    ])
    .then(
      axios.spread(
        (
          configRes,
          specialtiesRes,
          practitionersRes,
          locationsRes,
          timezonesRes
        ) => {
          const config = deepGet(configRes, ["data"]);
          dispatch({
            type: PORTAL_ACTION.CONFIG_LOAD_SUCCESS,
            payload: { config }
          });
          const specialtyTypes = deepGet(specialtiesRes, [
            "data",
            "specialtyTypes"
          ]);
          dispatch({
            type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
            payload: {
              key: "specialtyTypes",
              values: specialtyTypes
            }
          });
          const practitioners = deepGet(practitionersRes, [
            "data",
            "practitioners"
          ]);
          dispatch({
            type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
            payload: {
              key: "practitioners",
              values: practitioners
            }
          });
          locations = deepGet(locationsRes, ["data", "locations"]);
          const timezones = deepGet(timezonesRes, [
            "data",
            "locationTimezones"
          ]);

          dispatch({
            type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
            payload: {
              key: "timeZones",
              values: timezones
            }
          });
        }
      )
    )
    .catch(error => {
      dispatch(
        showError({
          text: error.response.data.Message,
          canDismiss: false
        })
      );
      dispatch(loading(false));
    });
  const hasLocationGroup = getParameterByName("lg");

  try {
    const { data } = await getSchedules(
      hasLocationGroup ? locations.map(l => l.locationId) : null
    );
    const { schedules } = data;
    dispatch({
      type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
      payload: {
        key: "schedules",
        values: schedules
      }
    });
    const locationsFilteredBySchedules = helpers.filterLocationsBySchedules(
      locations,
      schedules
    );

    dispatch({
      type: DATASOURCE_ACTION.UPDATE_DATASOURCE,
      payload: {
        key: "locations",
        values: locationsFilteredBySchedules
      }
    });
    dispatch(loading(false));
    locationsFilteredBySchedules.forEach(location => {
      portalService.getLocationPosition(location).then(({ data }) => {
        if (data != null) {
          const { lat, lng } = data;
          dispatch(
            updateLocationPosition(location.locationId, {
              lat,
              lng
            })
          );
        }
      });
    });
  } catch (error) {
    dispatch(
      showError({
        text: error.response.data.Message,
        canDismiss: false
      })
    );
    dispatch(loading(false));
  }
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/actions/portalActions.js